import { z } from "zod";
import { CyclePersonSchema } from "./reviewCycleSchemas.ts";
import { ScoreBucketGranularitySchema } from "./scoreBuckets.ts";
import { ScoreDistributionSchema } from "./scoreDistribution.ts";

export const CycleScoreSummarySchema = z.object({
    granularity: ScoreBucketGranularitySchema,
    overall: ScoreDistributionSchema
});

export type CycleScoreSummary = z.infer<typeof CycleScoreSummarySchema>;

export const CycleRevieweeScoreSchema = z.object({
    member: CyclePersonSchema,
    jobTitle: z.string().optional(),
    departmentLabel: z.string().optional(),
    overallScore: z.number().nullable()
});

export type CycleRevieweeScore = z.infer<typeof CycleRevieweeScoreSchema>;
